module.exports = {
      id: "astrology-usage",
      viewBox: "0 0 29.4 29.4",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#astrology",
      toString: function () {
        return this.url;
      }
    }